module.exports = __webpack_public_path__ + "static/media/upwardsdings.03ce1980.mp3";